<div *ngIf="(isAuthenticated$ | async) === true;">
  <header class="mat-elevation-z4 mb-3">
    <nav id="nav" class="container navbar navbar-expand-sm navbar-toggleable-sm fixed-top mat-elevation-z4 mt-0" style="background-color:#cc0000">
      <div class="container">
        <a class="navbar-brand mt-0" [routerLink]="['/']"><img src="/assets/halliburton-logo-white.png" /></a>
        <button class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target=".navbar-collapse"
                aria-label="Toggle navigation"
                [attr.aria-expanded]="isExpanded"
                (click)="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse"
             [ngClass]="{ show: isExpanded }">

          <ul class="navbar-nav flex-grow">
            <li class="nav-item mr-1" color="accent"
                [routerLinkActive]="['link-active','font-weight-bold']"
                [routerLinkActiveOptions]="{ exact: true }">
              <a class="nav-link text-white" [routerLink]="['/']">About Us</a>
            </li>
            <li class="nav-item " [routerLinkActive]="['link-active','font-weight-bold']">
              <a class="nav-link text-white" [routerLink]="['/announcements']">Announcements</a>
            </li>
            <li class="nav-item  mr-1" [routerLinkActive]="['link-active','font-weight-bold']">
              <a class="nav-link text-white" [routerLink]="['/form']">LCGPA Registration Form</a>
            </li>
            <li class="nav-item " [routerLinkActive]="['link-active','font-weight-bold']">
              <a class="nav-link text-white" [routerLink]="['/contact']">Contact Us &nbsp; | </a>
            </li>
            <li *ngIf="userName$ | async as userName" class="nav-item " [routerLinkActive]="['link-active','font-weight-bold']">
                <p class="nav-link text-white" > {{ userName }} </p>
            </li>
            <li class="nav-item ">
              <p><a class="nav-link text-white" href="" (click)="signOut();">Logout</a></p>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="divBanner" style="background-image: url('/assets/Ad4_Image.jfif');height:500px;background-size:100% 100%;margin-top:84px;"></div>
  </header>

</div>
